export class OnevocaNewDialogRadioButton {
  id: number;
  title: string;
  checked: boolean;

  constructor(id: number, title: string, checked: boolean) {
    this.id = id;
    this.title = title;
    this.checked = checked;
  }
}
